import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { PaperClipOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';
import { Button, Image, Upload } from 'antd';
import type { GetProp, UploadFile, UploadProps } from 'antd';
import container from '@/lib/di/container';
import { MediaRepo } from '@/core/repos/tables/media.repo';
import { RcFile } from 'antd/es/upload';

type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];

interface MediaUploadFile extends UploadFile {
    isUploaded?: boolean
}

const mediaRepo = container.get(MediaRepo);

export interface UploadFormHandle {
    saveUploadedFiles: (referenceId: string) => Promise<void>;
    reset: () => void
};

export const UploadForm = forwardRef<any, any>(({objectType, referenceId, text}, ref) => {
    const [deletedFileList, setDeletedFileList] = useState<MediaUploadFile[]>([]);
    const [fileList, setFileList] = useState<MediaUploadFile[]>([]);

    const getUploadedFiles = async (objectType: string, referenceId: string) => {
        const mediaList = await mediaRepo.list(objectType, referenceId);
        const _fileList: MediaUploadFile[] = mediaList.map((media) => ({
            uid: media.id,
            name: media.name??Date.now().toString(),
            status: "done",
            url: media.path,
            isUploaded: true
        }))
        setFileList(_fileList);
    }

    useImperativeHandle(ref, () => ({
        async saveUploadedFiles(referenceId: string) {
            const uploads: Promise<boolean>[] = [];
            fileList.forEach(file => {
                if (!file.isUploaded) {
                    const promise = mediaRepo.upload({
                        name: file.name,
                        objectType: objectType,
                        referenceId: referenceId,
                        id: ""
                    }, file as RcFile);
                    uploads.push(promise);
                }
            });
            const deleteResult = await mediaRepo.deleteFiles(deletedFileList.map(file => file.uid));
            const uploadResult = await Promise.all(uploads);
            console.log(deleteResult, uploadResult);
            await init();
        },

        reset() {
            setFileList([]);
            setDeletedFileList([]);
        }
    }));

    const init = async () => {
        setFileList([]);
        setDeletedFileList([]);
        if (referenceId) {
           await getUploadedFiles(objectType, referenceId)
        }
    }

    useEffect(()=>{
        init();
    }, [objectType, referenceId]);

    const beforeUpload: UploadProps['beforeUpload'] = (file) => setFileList([...fileList, file]);
    const onRemove = (file: MediaUploadFile) => {
        const index = fileList.indexOf(file);
        const newFileList = fileList.slice();
        newFileList.splice(index, 1);
        setFileList(newFileList);
        if (file.isUploaded) {
            setDeletedFileList([...deletedFileList, file])
        }
    }

  return (
    <>
        <p className="mb-2 text-[16px] font-[400]" style={{color: "var(--primary-label)"}}>{text}</p>
        <Upload
            listType='picture-card'
            fileList={fileList}
            beforeUpload={beforeUpload}
            onRemove={onRemove}
        >
            <button style={{ border: 0, background: 'none' }} type="button">
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>Thêm file</div>
            </button>
        </Upload>
    </>
  );
})

UploadForm.displayName = "UploadForm";